import loadable from '@loadable/component';

export const CourseSharePage = loadable(/* #__LOADABLE__ */ () => import('./CourseSharePage'));
